// src/pages/public/DonatePage.jsx

// STRIPE DEFAULT COLORS: 33d17a FOR BUTTON AND c0bfbc FOR BACKGROUND
// https://dashboard.stripe.com/acct_1OyLD6KE0e1CFeGp/settings/branding/checkout

// https://dashboard.stripe.com/acct_1OyLD6KE0e1CFeGp/settings/branding






// --- React Hooks ---
import React, { useState } from 'react';

// --- Component Imports ---
import PageWrapper from './PageWrapper'; // The essential wrapper for all pages
import Box from '@mui/material/Box'; // For responsive layout with sx prop

// --- Styles Imports ---
import {
    colors, // Assuming colors is imported from constants via PageStyles or directly
    introHeadingStyles, // For page title
    introSubHeadingStyles, // For general paragraph text
} from 'styles/PageStyles'; // Adjust path based on your setup







import { useEffect, useRef, } from 'react';
import { useLocation } from 'react-router-dom';










import less_alpha_padding_logo from 'pages_centennial/assets/0901/less_alpha_padding_logo.png'









// --- Optional: Import form-specific CSS if you have it ---
// import 'styles/form.css'; // For .form-control styles, including autofill overrides

/**
 * DonatePage: A page component for accepting donations with a Stripe integration overview.
 */
const DonateSuccess = () => {












    const navbarHeight = '4rem';
    const pageRef = useRef(null); // Create a ref for the page's main container

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(100, 0);
    }, [location]); // Run this effect whenever the location changes









    // State for donation amount
    const [donationAmount, setDonationAmount] = useState('');

    const onChange = e => {
        // Allow only numbers and ensure it's a valid amount
        const value = e.target.value.replace(/[^0-9.]/g, ''); // Allow only digits and one decimal
        setDonationAmount(value);
    };

    const onSubmit = e => {
        e.preventDefault();
        // --- This is where you'd initiate the Stripe payment process ---
        console.log('Initiating donation for:', donationAmount);
        alert(`Initiating Stripe payment for $${donationAmount}. (This is a placeholder action)`); // Use a custom modal in production
        // In a real app, you'd integrate with Stripe.js here.
    };

    // Styles for the main content area, consistent with your TemplatePage
    const mainContentAreaStyles = {
        padding: '20px',
        minHeight: '80vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: '10px',
        boxShadow: '0 0 20px rgba(0,0,0,0.7)',
        margin: '2rem auto', // Center the content area
        width: '90%',
        maxWidth: '900px',
        color: colors.textColor,
        textAlign: 'center',
    };

    // Styles for form inputs and labels, derived from your LoginPage
    const formInputStyle = {
        color: 'white',
        backgroundColor: 'black',
        border: '2px solid #006993', // Assuming this color is defined elsewhere or directly in colors
        width: '100%', // Make inputs fill their container
        padding: '10px',
        borderRadius: '5px',
        boxSizing: 'border-box', // Include padding in width
    };

    const formLabelStyle = {
        color: colors.textColor,
        fontSize: '1rem',
        marginBottom: '5px',
        display: 'block', // Make label a block element for better spacing
        textAlign: 'left', // Align label text to the left
    };

    const formGroupStyle = {
        marginBottom: '15px', // Space between form groups
    };

    const submitButtonStyle = {
        backgroundColor: colors.accentColor, // Use your accent color for the button
        color: colors.textColor,
        padding: '10px 20px',
        borderRadius: '5px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        border: 'none', // Remove default button border
        marginTop: '20px',
        '&:hover': {
            backgroundColor: colors.accentColor,
            opacity: 0.9,
            boxShadow: '0 0 10px rgba(255,255,255,0.5)',
        },
    };









    const sectionContainerStyle = {
        margin: '1rem',
    }



    const customBulletListStyle = {
        textAlign: 'left',
        listStyle: 'disc', // Standard disc bullet
        paddingLeft: '25px', // Indent the list
        color: colors.textColor, // Inherit text color
        fontSize: '1.1rem', // Consistent font size
        lineHeight: '1.6', // Good line height
        marginTop: '15px', // Space above the list
    };

    const listItemTextStyle = {
        marginBottom: '8px', // Space between list items
        // Add any other specific styles for list item text here
    };
























    let subscriptionOptionsRenderArray = [
        {
            id: 1,
            name: 'test name',
            price: '0.00',
            stripe_reference_key: 'price_1S7N65KE0e1CFeGpTc6cJJI8',
            courses: [1, 2, 3]
        }
    ]


    let user_email = 'test@test.com'


    let index = 0








    return (
        <PageWrapper navbarPermanent={true}> {/* Donate page typically has a permanent Navbar */}
            <div style={mainContentAreaStyles}>


                <div style={{margin:'3rem'}}></div>



                
                <h1 style={introHeadingStyles}>Support The Wonder Mission</h1>









                {/* 

                <div style={sectionContainerStyle}> 
    <h2 style={introHeadingStyles}>Integrating Stripe for Payments</h2>
    <p style={introSubHeadingStyles}>
        We propose integrating <a href="https://stripe.com/" target="_blank" rel="noopener noreferrer" style={{ color: colors.accentColor, textDecoration: 'none', fontWeight: 'bold' }}>Stripe</a>, a leading online payment processor, to enhance the donation experience. Stripe offers a seamless, professional, and secure platform for financial contributions, moving beyond the current PayPal link.
    </p>
    <p style={introSubHeadingStyles}>
        Payment information is encrypted and processed directly by Stripe. This means sensitive card details will never pass through our website's servers, ensuring the highest level of security for financial contributions.
    </p>
    <p style={introSubHeadingStyles}>
        Integrating Stripe will provide a smoother and more polished experience for users because:
    </p>
    <ul style={customBulletListStyle}> 
        <li style={listItemTextStyle}>
            It can be integrated directly into this website, without redirecting to another site.
        </li>
        <li style={listItemTextStyle}>
            Payment is handled through a Stripe-powered popup modal.
        </li>
        <li style={listItemTextStyle}>
            Users can pay directly with credit or debit card; no account is required.
        </li>
        <li style={listItemTextStyle}>
            Stripe has a well-documented API and is excellent for this type of integration.
        </li>
    </ul>
</div> */}
















                <div style={{ margin: '1rem' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '20px',
                            width: '100%',
                            maxWidth: '500px', // Limit form width
                            margin: '2rem auto',
                            padding: '20px',
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            borderRadius: '8px',
                            boxShadow: '0 0 15px rgba(0,0,0,0.5)',
                            border: '1px solid',
                            borderColor: colors.accentColor,
                        }}
                    >
                        <h2 style={{ ...introHeadingStyles, margin: '0px' }}>
                            Join The Mission
                        </h2>

                        <img
                            src={less_alpha_padding_logo}
                            alt="CENTENNIAL_LOGO_2"
                            style={{
                                maxWidth: '80%',
                                maxHeight: '15rem',
                                margin: '0rem auto',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                            }}
                        />

                        <p style={{ ...introSubHeadingStyles, textAlign: 'center' }}>
                            Thank you for supporting The Wonder Mission with your Donation!
                        </p>

                        {/* The simplified form that redirects to Stripe */}

                    </Box>
                </div>



























            </div>
        </PageWrapper>
    );
};

export default DonateSuccess;
